import { render } from "./Hiperfarma.vue?vue&type=template&id=e0e98434"
import script from "./Hiperfarma.vue?vue&type=script&lang=js"
export * from "./Hiperfarma.vue?vue&type=script&lang=js"

import exportComponent from "/Users/robo1/Documents/Admin/campanha-pedido/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__